import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Dialog, IconButton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Close as CloseIcon } from "@mui/icons-material";
import GivingFormV2 from "shared/components/giving-form-v2/App/GivingFormV2";
import { IntlProvider } from "react-intl";
import { fetchLocale } from "shared/helpers/localeHelper";
import givingFormLocales from "../../../shared/locales/givingForm";

import { closeModal } from "../../../ducks/modal";
import { setEntity } from "../../../ducks/entity";
import { resetGiftCreateRegistration } from "../../../ducks/matchingGifts";
import {
  resetCampaignSelections,
  setGivingStep,
  setIsAbandonForm,
  createAbandonForm,
  removeSelectedCampaign,
  setLoading,
} from "../../../ducks/givingFormV2";
import MixpanelService from "shared/services/MixpanelService";

const GlobalModal = ({
  currentCampaign,
  currentFormObjectDonatePayment,
  currentStep,
  entity,
  entityId,
  isAbandonForm,
  isModalOpen,
  language,
  onCloseModal,
  paypalClientId,
  removeSelectedCampaign,
  selectedCampaigns,
  selectedLocale,
  setEntity,
  setGivingStep,
  setIsAbandonForm,
  setLoading,
  resetGiftCreateRegistration,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const defaultLocale = fetchLocale(language);
  const selected = selectedLocale ? selectedLocale : defaultLocale;
  useEffect(() => {
    if (entity && entity.id) {
      setEntity(entity);
    }
  }, [entity, setEntity]);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") {
        handleCloseModal();
      }
    }
    if (isModalOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen]);

  const handleCloseModal = () => {
    if (currentStep === "givingDonationLevels") {
      removeSelectedCampaign(currentCampaign.id);
    }
    if (isAbandonForm) {
      const { firstName, lastName, email } = currentFormObjectDonatePayment;
      const params = {
        entity_id: entityId,
        campaign_id: selectedCampaigns[0].id,
        first_name: firstName,
        last_name: lastName,
        email: email,
      };

      createAbandonForm(params);
    }
    setIsAbandonForm(false);
    if (currentStep == "givingThankyouStep") {
      setLoading();
      document.location.reload(true);
    } else {
      setGivingStep("givingSelectionStep");
      onCloseModal();
    }
    resetGiftCreateRegistration();
    MixpanelService.trackGivingFormClick(currentStep, "close");
  };

  return (
    <IntlProvider locale={selected} messages={givingFormLocales[selected]}>
      <Dialog
        id="global-giving-form"
        open={isModalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullScreen={fullScreen}
        fullWidth={true}
        scroll="body"
        aria-labelledby="dialog-title"
        sx={{
          // position dialog at top of screen
          "& .MuiDialog-scrollPaper": { alignItems: "flex-start" },
          "& .MuiDialog-scrollBody > .MuiDialog-paper": { verticalAlign: "top" },
        }}
        slotProps={{
          paper: {
            sx: { borderRadius: fullScreen ? 0 : "20px" },
          },
        }}>
        <Fragment>
          <div className="modal-close-button">
            <IconButton
              data-testid="t-shared-compone--GlobalM-close"
              aria-label="close"
              onClick={handleCloseModal}
              size="large">
              <CloseIcon fontSize="large" />
            </IconButton>
          </div>
          <GivingFormV2 entityId={entityId} paypalClientId={paypalClientId} />
        </Fragment>
      </Dialog>
    </IntlProvider>
  );
};

const mapStateToProps = ({ modal, entity, givingFormV2 }) => {
  const { isModalOpen } = modal;

  const { language, selectedLocale } = entity;

  const {
    isAbandonForm,
    selectedCampaigns,
    currentFormObjectDonatePayment,
    currentStep,
    currentCampaign,
  } = givingFormV2;

  return {
    currentStep,
    currentCampaign,
    isModalOpen,
    language,
    isAbandonForm,
    selectedLocale,
    selectedCampaigns,
    currentFormObjectDonatePayment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setEntity: (entity) => dispatch(setEntity(entity)),
    onCloseModal: () => dispatch(closeModal()),
    setGivingStep: (step) => dispatch(setGivingStep(step)),
    handleResetCampaigns: () => dispatch(resetCampaignSelections()),
    setIsAbandonForm: (bool) => dispatch(setIsAbandonForm(bool)),
    createAbandonForm: (values) => dispatch(createAbandonForm(values)),
    removeSelectedCampaign: (campaignId) => dispatch(removeSelectedCampaign(campaignId)),
    setLoading: () => dispatch(setLoading()),
    resetGiftCreateRegistration: () => dispatch(resetGiftCreateRegistration()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalModal);
